import { Box } from 'lucide-react';
import { cn } from '@strivelabs/ui-core/lib/utils';

/**
 * The mark an artifact wears, wherever one is named.
 *
 * A holder rather than a bare glyph, and the same holder in chat as in the task
 * panel: the cube on its own read as one more grey icon in a row of them, where
 * the cream tile says "a page Strive wrote" at a glance. The design's own
 * `.af-ic--art` — a 28px tile on an 8px radius, the cream over white, and the
 * cube in the cream's own hue a few steps darker (4.4:1, so it holds its
 * stroke) rather than ink sitting on it.
 */
export const ArtifactIcon = ({ className }: { className?: string }) => (
  <span
    aria-hidden
    className={cn(
      'inline-flex size-7 shrink-0 items-center justify-center rounded-lg bg-[#FBF7EE]',
      className,
    )}
  >
    <Box className="size-[18px] text-[#857147]" />
  </span>
);
